import createIcon from '../../createIcon';

/**
 * @component @name AddModerator
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNzIgMjIuNjFDMTIuMzIgMjIuNzYgMTEuOTIgMjIuOSAxMS41IDIzQzYuMzQgMjEuNzQgMi41IDE2LjU1IDIuNSAxMVY1TDExLjUgMUwyMC41IDVWMTFDMjAuNSAxMS45IDIwLjM5IDEyLjc4IDIwLjIgMTMuNjVDMTkuMzkgMTMuMjQgMTguNDcgMTMgMTcuNSAxM0MxNC4xOSAxMyAxMS41IDE1LjY5IDExLjUgMTlDMTEuNSAyMC4zNiAxMS45NiAyMS42MSAxMi43MiAyMi42MVpNMTguNSAyMFYyMi45OUMxOC41IDIyLjk5IDE2LjUxIDIzIDE2LjUgMjIuOTlWMjBIMTMuNVYxOEgxNi41VjE1SDE4LjVWMThIMjEuNVYyMEgxOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddModerator = createIcon('AddModerator', [
  [
    'path',
    {
      d: 'M12.72 22.61C12.32 22.76 11.92 22.9 11.5 23C6.34 21.74 2.5 16.55 2.5 11V5L11.5 1L20.5 5V11C20.5 11.9 20.39 12.78 20.2 13.65C19.39 13.24 18.47 13 17.5 13C14.19 13 11.5 15.69 11.5 19C11.5 20.36 11.96 21.61 12.72 22.61ZM18.5 20V22.99C18.5 22.99 16.51 23 16.5 22.99V20H13.5V18H16.5V15H18.5V18H21.5V20H18.5Z',
      key: '1paep8',
    },
  ],
]);

export default AddModerator;
